define('collection/TimeZoneCollection',['require','lib/collection/BaseCollection','model/TimeZoneModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var TimeZoneModel = require('model/TimeZoneModel');

    /**
     * Time zone list collection
     *
     * @class TimeZoneCollection
     */
    return BaseCollection.extend({

        url: '/time-zone/',
        model: TimeZoneModel

    });

});
